import React from 'react';
import { Dropdown, MenuItem, FormController, FormLabel, } from '@one-thd/sui-atomic-components';
export const formatCityState = (city, state) => {
    return `${city}, ${state}`;
};
export const CityStateSelect = React.forwardRef((props, ref) => {
    const { cities } = props;
    return (React.createElement(FormController, { fullWidth: true },
        React.createElement(FormLabel, null, "City, State*"),
        React.createElement(Dropdown, Object.assign({ label: props.value, ref: ref, placeholder: "" }, props), (cities === null || cities === void 0 ? void 0 : cities.length) &&
            cities.map(({ city, state }) => (React.createElement(MenuItem, { key: city, value: formatCityState(city, state) }, formatCityState(city, state)))))));
});
